// extracted by mini-css-extract-plugin
export default {"ganttVerticalContainer":"gantt_ganttVerticalContainer__JSY2c","horizontalContainer":"gantt_horizontalContainer__Gj1Iq","wrapper":"gantt_wrapper__Yhhnn"};